import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Overlay, Ratio, Tooltip } from 'react-bootstrap'
import Price from './Price'
import { isMobile } from 'react-device-detect'
import ScrollableImage from './dynamic/ScrollableImage'
import { MODEL_VIEWER_HOST } from '../../constants/constants'

const CardOption = (props) => {
   const {
      step,
      option,
      formState,
      setFormState,
      selected,
      basketState,
      setBasketState,
      keyV
   } = props
   const { price: stepPrice } = step
   const { img,
      forceClick,
      title,
      optionName,
      optionValue,
      materialListId,
      materialId,
      price
   } = option
   const [cardBorderClass, setCardBorderClass] = useState('')
   const [showToolTip, setShowToolTip] = useState(false)
   const radio = useRef()
   const card = useRef()

   useEffect(() => {
      if (forceClick) {
         handleClick({})
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [forceClick, materialListId])

   useEffect(() => {
      setCardBorderClass(selected ? 'danger' : '')
   }, [selected])

   const handleClick = (e) => {
      const id = materialId
      changeMaterial(materialListId, id)
      if (!forceClick && materialId !== 'configurator_flashes_tartan') {

         formState[optionName] = radio.current.value
      }
      setFormState(formState)
      if (!forceClick) {
         basketState[optionName] = option
         if (step.price) {
            basketState[step.optionName] = { ...step }
         }
         setBasketState(basketState)
      }


   }

   const changeMaterial = (materialListId, id) => {
      const frame = document.getElementById('modelFrame')
      const action = { action: 'CHANGE_MATERIAL', payload: { materialListId, id } }
      frame.contentWindow.postMessage(action, MODEL_VIEWER_HOST)
   }

   const handleMouseOver = () => {
      !selected && setCardBorderClass('primary shadow')
      setShowToolTip(true)
   }

   const handleMouseOut = () => {
      !selected && setCardBorderClass('')
      setShowToolTip(false)
   }

   return (
      <Col key={keyV}>
         <Overlay
            show={showToolTip}
            placement='top'
            target={card.current}
         >
            {(props) => (
               <Tooltip id={optionValue} {...props}>
                  {title} <Price prefix={stepPrice ? '+' : ''}{...price} />
               </Tooltip>
            )}

         </Overlay>

         <label className='w-100'>
            <input
               checked={selected}
               ref={radio}
               type="radio"
               name={optionName}
               className="d-none"
               value={optionValue}
               onChange={(e) => optionName === 'kiltTartan' ? null : handleClick(e)}
            >
            </input>
            <Card
               ref={card}
               border={cardBorderClass}
               className={`${selected ? 'shadow' : ''} rounded-0 optionsCard`}
               style={{ borderWidth: selected ? '2px' : '' }}
               onMouseOver={handleMouseOver}
               onMouseOut={handleMouseOut}
            // onClick={handleClick}
            >
               {optionName === 'kiltTartan' ?
                  <Ratio aspectRatio="1x1"><ScrollableImage onClick={handleClick} className='rounded-0' variant="top" src={img} /></Ratio> :
                  <Card.Img className='rounded-0' src={img} alt={title} />}

            </Card>
         </label>
      </Col >
   )
}
export default CardOption